// shared/workspace-constants.ts
// Client- and server-safe constants for the active-workspace protocol.

// Header the client sends to select the active workspace. Never trusted on its
// own — the server validates membership in getWorkspaceContextFromRequest.
export const WORKSPACE_HEADER = "x-workspace-id";

// Response code the client interceptor watches for to auto-switch to the
// personal workspace when access to the active one was revoked/frozen.
export const WORKSPACE_ACCESS_REVOKED = "WORKSPACE_ACCESS_REVOKED";
export const WORKSPACE_FROZEN = "WORKSPACE_FROZEN";
